// src/utils/helpers/languageHelpers.ts

// Language
export const isRTLLanguage = (lang: string) => {
  const rtlLanguages = ["fa", "ar", "ur", "he"];
  return rtlLanguages.includes(lang);
};


// Text
export const isRTLText = (text: string): boolean => {
  const rtlCharRegex = /[\u0600-\u06FF\u0750-\u077F\u08A0-\u08FF]/;
  return rtlCharRegex.test(text);
};